import { render, staticRenderFns } from "./AdminChart.vue?vue&type=template&id=3d859352&"
import script from "./AdminChart.vue?vue&type=script&lang=js&"
export * from "./AdminChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports